<div class="col-flex-container">
  <div class="col-container">
    <div class="f-col d-align-center">
      <div class="illustration-wrapper">
        <div class="img-wrapper">
          <img *ngIf="config?.heading != 'Your link has expired'" src="assets/images/illustrations--Thankyou.svg"
            alt="Thankyou" />
          <img *ngIf="config?.heading == 'Your link has expired'"
            src="assets/images/illustrations--SomthingWentWrong.svg" alt="Thankyou" />
        </div>
      </div>

      <div class="description-wrapper">

        <h4 class="title-text m-top-24">
          {{ config?.heading }}
        </h4>

        <p class="description-text m-top-8x" *ngIf="config.description">
          {{ config.description }}
        </p>

        <div class="f-col d-align-center m-top-40" *ngIf="config.isShowButton">
          <button mat-button class="button--primary-small" (click)="redirect()">
            {{ config.buttonText }}
            @if(config.isShowIcon){
            <mat-icon fontSet="material-symbols-outlined">arrow_forward</mat-icon>
            }
          </button>
        </div>

      </div>


    </div>
  </div>
</div>